<template>
  <figure v-once v-html="src" class="inline-svg" :data-context="context" />
</template>

<script>
  // see vue-loader.conf
  export default {
    props: [ 'src', 'context' ]
  }
</script>

<style lang="scss">
  figure.inline-svg {
    width: 100%;
    height: auto;

    &[data-context = "home-featured"] {
      & svg {
        fill: #fff;
      }
    }

    &[data-context = "work-list"] {
      & svg {
        display: block;
        margin: 0 auto;
        fill: $color-black;
        width: 40%;
        max-width: 200px;
        transition: fill 0.1s linear;
      }

      .hover & {
        & svg {
          fill: #fff;
        }
      }

      .t2 & {
        & svg {
          width: 20%;
        }
      }

      .rbi-emails & {
        & svg {
          width: 27%;
        }
      }

      .biscuit & {
        & svg {
          width: 30%;
        }
      }

      .zigzag &, .barefoot &, .rbi-report &, .rbi-website &, .olasio & {
        & svg {
          width: 35%;
        }
      }

      .granton &, .wikiprice &, .rbi-scheduler & {
        & svg {
          width: 42%;
        }
      }

      .transcope & {
        & svg {
          width: 48%;
        }
      }

      .magritte & {
        & svg {
          width: 52%;
        }
      }
    }
  } //figure
</style>



// WEBPACK FOOTER //
// src/components/Vector.vue